import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './pedidoForm';
import FormatUtils from '../common/formatUtils/FormatUtils';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import DateFormat from '../common/dateFormat/DateFormat';
import Aguardando from '../common/template/aguardando';
import ReactExport from 'react-export-excel-fixed-xlsx';

import { 
	getListaAnalise, getListaUnidade, getListaProduto,
	getListaUsuario,
	getListaPedidoTipo, getListaPedidoFrete, getListaPedidoCnpj
} from './pedidoActions';
import { getLista as getListaPedidoPrazo } from '../pedidoPrazo/pedidoPrazoActions';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Select from '../common/form/select';

class PedidoEntrega extends Component {

	state = {
		linhaSelecionada: null,
		dataInicial: DateFormat.formatarDataSqlParaTela(DateFormat.getTimestampParaData(new Date().getTime() - 2592000000)),
		dataFinal: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()),
		cardsSelecionados: [1, 2, 3]
	}

    componentWillMount() {
		this.props.getListaAnalise(this.state.dataInicial, this.state.dataFinal);
		this.props.getListaUnidade();
		this.props.getListaProduto();
		this.props.getListaUsuario();
		this.props.getListaPedidoTipo();
		this.props.getListaPedidoFrete();
		this.props.getListaPedidoCnpj();
		this.props.getListaPedidoPrazo();
	}
	
	componentWillUnmount() {

	
    }

    render() {
        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.lista()}
                </Content>
            </div>
        )
    }

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.props.lista.filter(item => {
			if (this.state.id_unidade && item.id_unidade != this.state.id_unidade) {
				return false;
			}
			if (this.state.id_produto && item.id_produto != this.state.id_produto) {
				return false;
			}
			if (this.state.id_usuario && item.id_usuario_inclusao != this.state.id_usuario) {
				return false;
			}
			if (this.state.pesquisar
				&& !(`
					${item.giro}
					${DateFormat.formatarDataSqlParaTela(item.datahora_pedido)}
					${item.nome_status}
					${FormatUtils.formatarValorTelaDecimal(item.quantidade_s10, 0)}
					${FormatUtils.formatarValorTelaDecimal(item.preco_unitario_s10, 0)}
					${FormatUtils.formatarValorTelaDecimal(item.quantidade_s500, 0)}
					${FormatUtils.formatarValorTelaDecimal(item.preco_unitario_s500, 0)}
					${item.clientes}
					${item.venda_perdida ? item.concorrente : ''}
					${item.venda_perdida ? FormatUtils.formatarValorTelaDecimal(item.preco_concorrente_s10, 4) : ''}
					${item.venda_perdida ? FormatUtils.formatarValorTelaDecimal(item.preco_concorrente_s500, 4) : ''}
				`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}

			if (!this.state.cardsSelecionados.includes(1)) {
				if ([1, 2].includes(item.id_status)) {
					return false;
				}
			}
			if (!this.state.cardsSelecionados.includes(2)) {
				if ([4, 5, 6, 7, 8].includes(item.id_status)) {
					return false;
				}
			}
			if (!this.state.cardsSelecionados.includes(3)) {
				if (item.venda_perdida || [3].includes(item.id_status)) {
					return false;
				}
			}

			return true;
		});

		/*
		1-Digitando
		2-Aguardando Aprovação
		3-Rejeitado
		4-Aprovado
		5-Logística Parcial
		6-Logística Finalizada
		7-Finalizado Base
		8-Abast. Base e Aguard. Faturar
		*/

		let quantidadeVendaPerdidaS10 = 0;
		let quantidadeVendaPerdidaS500 = 0;
		let quantidadeNegociacaoS10 = 0;
		let quantidadeNegociacaoS500 = 0;
		let quantidadeFechadaS10 = 0;
		let quantidadeFechadaS500 = 0;
		lista.forEach(item => {
			if (item.venda_perdida || [3].includes(item.id_status)) {
				quantidadeVendaPerdidaS10 += parseFloat(item.quantidade_s10 || 0);
				quantidadeVendaPerdidaS500 += parseFloat(item.quantidade_s500 || 0);
			} else if ([1, 2].includes(item.id_status)) {
				quantidadeNegociacaoS10 += parseFloat(item.quantidade_s10 || 0);
				quantidadeNegociacaoS500 += parseFloat(item.quantidade_s500 || 0);
			} else if ([4, 5, 6, 7, 8].includes(item.id_status)) {
				quantidadeFechadaS10 += parseFloat(item.quantidade_s10 || 0);
				quantidadeFechadaS500 += parseFloat(item.quantidade_s500 || 0);
			}
		})
		
		const cards = [{
			id: 1,
			nome: 'Em Negociação',
			quantidadeS10: quantidadeNegociacaoS10,
			quantidadeS500: quantidadeNegociacaoS500,
			icone: 'fas fa-comment-dollar',
			cor: 'primary'
		}, {
			id: 2,
			nome: 'Venda Fechada',
			quantidadeS10: quantidadeFechadaS10,
			quantidadeS500: quantidadeFechadaS500,
			icone: 'fas fa-file-invoice-dollar',
			cor: 'success'
		}, {
			id: 3,
			nome: 'Venda Perdida',
			quantidadeS10: quantidadeVendaPerdidaS10,
			quantidadeS500: quantidadeVendaPerdidaS500,
			icone: 'fas fa-ban',
			cor: 'danger'
		}];

		return (
			<ContentCard>
	
				<ContentCardHeader>
					<Row>
						<LabelAndInputMask
							name='data_inicial'
							label='Data Inicial' placeholder='Informe a data'
							cols='12 6 2 1'
							mask='99/99/9999'
							minWidth={140}
							value={this.state.dataInicial}
							onChange={data => {
								this.setState({
									...this.state,
									dataInicial: data.target.value
								});
							}} />

						<LabelAndInputMask
							name='data_final'
							label='Data Final' placeholder='Informe a data'
							cols='12 6 2 1'
							mask='99/99/9999'
							value={this.state.dataFinal}
							minWidth={140}
							onChange={data => {
								this.setState({
									...this.state,
									dataFinal: data.target.value
								});
							}} />

						<Select
							options={this.props.listaUnidade}
							label='Unidade'
							cols='12 6 4 2'
							placeholder='Selecione a unidade'
							value={this.state.id_unidade}
							onChange={value => this.setState({ ...this.state, id_unidade: value })} />

						<Select
							options={this.props.listaUsuario}
							label='Representante'
							cols='12 6 4 2'
							placeholder='Selecione o representante'
							value={this.state.id_usuario}
							onChange={value => this.setState({ ...this.state, id_usuario: value })} />
														
						<Grid cols='6 6 4 1' style={{ paddingTop: 28 }}>
							<Button
								text='Atualizar'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.getListaAnalise(this.state.dataInicial, this.state.dataFinal);
								}} />
						</Grid>
						{/*<Grid cols='6 6 3 1' style={{ marginTop: 28 }}>
							<ExcelFile
								filename={'Pedidos'}
								element={
									<Button
									text='Exportar'
									type={'primary'}
									icon={'fa fa-plus'} />
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									datahora_logistica: DateFormat.formatarDataHoraSqlParaTela(item.datahora_logistica),
									data_emissao_nfe: DateFormat.formatarDataSqlParaTela(item.data_emissao_nfe),
									datahora_entrega: DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrega),
									quantidade: FormatUtils.formatarValorTelaDecimal(item.quantidade, 0),
								}))} name='Pedidos'>									
									<ExcelColumn label='Log. Finalizada' value='datahora_logistica' />
									<ExcelColumn label='Data NF-e' value='data_emissao_nfe' />
									<ExcelColumn label='Finalizado Base' value='datahora_entrega' />
									<ExcelColumn label='Status' value='nome_status' />
									<ExcelColumn label='Unidade' value='nome_unidade' />
									<ExcelColumn label='Giro' value='giro' />
									<ExcelColumn label='NF-e' value='numero_nfe' />
									<ExcelColumn label='Motorista' value='nome_motorista' />
									<ExcelColumn label='Placa' value='placa_veiculo' />
									<ExcelColumn label='Vendedor' value='nome_usuario_inclusao' />
									<ExcelColumn label='Cliente' value='nome_cliente' />
									<ExcelColumn label='Endereço' value='nome_endereco' />
									<ExcelColumn label='Produto' value='nome_produto' />
									<ExcelColumn label='Quantidade' value='quantidade' type='number' />
								</ExcelSheet>
							</ExcelFile>
						</Grid>*/}
					</Row>
				</ContentCardHeader>

				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 style={{ marginBottom: 8 }}
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Row alignCenter>
						{cards.map(item => (
							<Grid key={item.id} cols='12 4 4 3'>
								<div class='info-box mb-3'>
									<span class={`info-box-icon bg-${(this.state.cardsSelecionados || []).includes(item.id) ? item.cor : 'secondary'} elevation-1`}
										style={{
											cursor: 'pointer'											
										}}
										onClick={() => {
											let selecionados = (this.state.cardsSelecionados || []);
											if (selecionados.includes(item.id)) {
												selecionados = selecionados.filter(idSelecionado => idSelecionado != item.id);
											} else {
												selecionados.push(item.id);
											}
											this.setState({
												cardsSelecionados: selecionados
											});
										}}	><i class={item.icone}></i>
									</span>
									<div class='info-box-content'>
									<span class='info-box-text' style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'center', paddingBottom: 4 }}>{item.nome}</span>
										<span class='info-box-number' style={{ fontSize: 22, fontWeight: 'bold', textAlign: 'center', paddingTop: 4 }}>{FormatUtils.formatarValorTelaDecimal(item.quantidadeS10 + item.quantidadeS500, 0)} L</span>
									</div>
								</div>
							</Grid>
						))}
						{/*cards.map(item => (
							<Grid key={item.id} cols='12 4 4 2' style={{ backgroundColor: '#f2c2b8', paddingTop: 16, paddingBottom: 0 }}>
								<div class='info-box mb-3'>
									<span class={`info-box-icon bg-${(this.state.cardsSelecionados || []).includes(item.id) ? item.cor : 'secondary'} elevation-1`}
										style={{
											cursor: 'pointer'											
										}}
										onClick={() => {
											let selecionados = (this.state.cardsSelecionados || []);
											if (selecionados.includes(item.id)) {
												selecionados = selecionados.filter(idSelecionado => idSelecionado != item.id);
											} else {
												selecionados.push(item.id);
											}
											this.setState({
												cardsSelecionados: selecionados
											});
										}}	><i class={item.icone}></i>
									</span>

									<div class='info-box-content'>
										<span class='info-box-text' style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'center', paddingBottom: 4 }}>{item.nome} - S500</span>
										<span class='info-box-number' style={{ fontSize: 22, fontWeight: 'bold', textAlign: 'center', paddingTop: 4 }}>{FormatUtils.formatarValorTelaDecimal(item.quantidadeS500, 0)} L</span>
									</div>
								</div>
							</Grid>
						))*/}
					</Row>
					<Table responsive border>
						<THead>
							<Tr>
								<Th alignCenter>Giro</Th>
								<Th alignCenter>Data</Th>
								<Th alignCenter>Status</Th>
								<Th alignCenter>Qtd S10</Th>
								<Th alignCenter>Preço S10</Th>
								<Th alignCenter>Qtd S500</Th>
								<Th alignCenter>Preço S500</Th>
								<Th alignCenter>Clientes</Th>
								<Th alignCenter>Concorrente</Th>
								<Th alignCenter title={'Preço do Concorrente'}>Preço S10</Th>
								<Th alignCenter title={'Preço do Concorrente'}>Preço S5000</Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => {
								return (
									<Tr key={`${item.id} ${item.id_item}`} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
										onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td alignCenter small>{item.giro}</Td>
										<Td alignCenter small>{DateFormat.formatarDataSqlParaTela(item.datahora_pedido)}</Td>
										<Td alignCenter small>{item.nome_status}</Td>
										<Td alignRight small>{FormatUtils.formatarValorTelaDecimal(item.quantidade_s10, 0)}</Td>
										<Td alignRight small>{FormatUtils.formatarValorTela(item.preco_unitario_s10, 4)}</Td>
										<Td alignRight small>{FormatUtils.formatarValorTelaDecimal(item.quantidade_s500, 0)}</Td>
										<Td alignRight small>{FormatUtils.formatarValorTela(item.preco_unitario_s500, 4)}</Td>
										<Td alignCenter minWidth={200} small noWrap>{item.clientes}</Td>										
										<Td alignCenter minWidth={200} small noWrap>{item.venda_perdida ? item.concorrente : ''}</Td>
										<Td alignRight small>{item.venda_perdida ? FormatUtils.formatarValorTela(item.preco_concorrente_s10, 4) : ''}</Td>
										<Td alignRight small>{item.venda_perdida ? FormatUtils.formatarValorTela(item.preco_concorrente_s500, 4) : ''}</Td>
									</Tr>
								);
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.pedido.aguardando,
	modoTela: state.pedido.modoTela,
	lista: state.pedido.listaAnalise,
	listaUnidade: state.pedido.listaUnidade,
	listaProduto: state.pedido.listaProduto,
	listaUsuario: state.pedido.listaUsuario
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	getListaAnalise, getListaUnidade, getListaProduto, getListaUsuario,
	getListaPedidoTipo, getListaPedidoFrete, getListaPedidoCnpj, getListaPedidoPrazo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoEntrega);
